import { useEffect, useState } from "react";

// react-router-dom components
import { useLocation } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React context
import {
  useMaterialUIController,
  setLayout,
  setSideBarVisibility,
} from "context";
import MDSnackbar from "components/MDSnackbar";

function DashboardLayout({ children }) {
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav } = controller;
  const { pathname } = useLocation();
  const { sideBarVisibility, successMessage, errorMessage } = controller;
  const [successSB, setSuccessSB] = useState(false);
  const [errorSB, setErrorSB] = useState(false);

  //Snack bar open/close methods
  const openSuccessSB = () => setSuccessSB(true);
  const closeSuccessSB = () => setSuccessSB(false);
  const openErrorSB = () => setErrorSB(true);
  const closeErrorSB = () => setErrorSB(false);

  useEffect(() => {
    setLayout(dispatch, "dashboard");
  }, [pathname]);

  useEffect(() => {
    if (!sideBarVisibility) {
      setSideBarVisibility(dispatch, true);
    }
  });

  useEffect(() => {
    if (successMessage) {
      openSuccessSB();
    } else {
      closeSuccessSB();
    }
  }, [successMessage]);

  useEffect(() => {
    if (errorMessage) {
      openErrorSB();
    } else {
      closeErrorSB();
    }
  }, [errorMessage]);

  const renderSuccessSB = (
    <MDSnackbar
      color="success"
      icon="check"
      title={successMessage?.title ? successMessage?.title : ""}
      content={successMessage?.content ? successMessage?.content : ""}
      dateTime=""
      open={successSB}
      onClose={closeSuccessSB}
      close={closeSuccessSB}
      bgWhite
    />
  );

  const renderErrorSB = (
    <MDSnackbar
      color="error"
      icon="warning"
      title={errorMessage?.title ? errorMessage?.title : ""}
      content={errorMessage?.content ? errorMessage?.title : ""}
      dateTime=""
      open={errorSB}
      onClose={closeErrorSB}
      close={closeErrorSB}
      bgWhite
    />
  );

  return (
    <MDBox
      className="right-container"
      sx={({ breakpoints, transitions, functions: { pxToRem } }) => ({
        p: 3,
        position: "relative",

        [breakpoints.up("xl")]: {
          marginLeft: miniSidenav ? pxToRem(120) : pxToRem(274),
          transition: transitions.create(["margin-left", "margin-right"], {
            easing: transitions.easing.easeInOut,
            duration: transitions.duration.standard,
          }),
        },
      })}
    >
      {children}
      {successMessage ? renderSuccessSB : <></>}
      {errorMessage ? renderErrorSB : <></>}
    </MDBox>
  );
}

// Typechecking props for the DashboardLayout
DashboardLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default DashboardLayout;
